import React from 'react';
import { makeStyles, createStyles, Grid } from '@material-ui/core';
import { Property } from '@lib/state';
import { PropertContact } from './property-contact.component';

interface Props {
  properties: Property[];
}

const useStyles = makeStyles(() =>
  createStyles({
    gridContainer: ({ count }: { count: number }) => ({
      display: 'flex',
      // center a single item, otherwise justify left
      justifyContent: count > 1 ? 'flex-start' : 'center',
    }),
  })
);

export const PropertyContactList: React.FC<Props> = ({ properties }) => {
  const { gridContainer } = useStyles({ count: properties.length });

  return (
    <Grid container spacing={2} className={gridContainer}>
      {properties.map((property, i) => (
        <Grid item md={6} xs={12} key={i}>
          <PropertContact property={property} />
        </Grid>
      ))}
    </Grid>
  );
};
